import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { Link } from "react-router-dom";
import waste from "../assets/images/reduce-waste.png";
import energy from "../assets/images/save-energy.png";
import water from "../assets/images/save-water.png";
import plastic from "../assets/images/single-use-plastic.png";
import healthy from "../assets/images/healthylife.png";
import food from "../assets/images/balanced-diet.png";
import ewaste from "../assets/images/reduce-e-waste.png";
import Carousel from "react-bootstrap/Carousel";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { FaArrowCircleLeft, FaArrowCircleRight } from "react-icons/fa";
import { FaLongArrowAltRight } from "react-icons/fa";
import { FaRegHandPointRight } from "react-icons/fa";
import Tab from "react-bootstrap/Tab";
import ThemeBaseRouting from "helper/ThemeBaseRouting";
import Tabs from "react-bootstrap/Tabs";
import banner from "../assets/images/sliderBg.jpg";
import banner22 from "../assets/images/slider01.png";
import modiji from "../assets/images/image.png";

import banner03 from "../assets/images/banner05.jpg";
import banner04 from "../assets/images/banner04.jpg";
import { ArrowRight } from "phosphor-react";
import { Image, Table } from "react-bootstrap";
import titleSample from "../assets/images/heading-breaker.png";
import igniting from "../assets/images/igniting.png";
import fostering from "../assets/images/fostering.png";
import globlazing from "../assets/images/globlazing.png";
import breaking from "../assets/images/breaking.png";
import empworing from "../assets/images/empworing.png";
import harnessing from "../assets/images/harnessing.png";
import measuring from "../assets/images/measuring.png";
import veer from "../assets/images/veer.png"
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useLocation } from "react-router-dom"; // Import useLocation
import { AppContext } from "../context"; // Import AppContext
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import TwitterEmbed from "./Twitter";
import arrowRight from "../assets/images/arrowIcn.png";
// import ecoVideo from "../assets/images/EcoClubs.mp4"
import one from "../assets/images/1.png"
import two from "../assets/images/2.png"
import three from "../assets/images/3.png"
import four from "../assets/images/4.png"
import five from "../assets/images/5.png"
import six from "../assets/images/6.png"
import { toast } from "react-toastify";
import Header from "../Components/HeaderSchool";
import SchoolLoginModel from "../Components/Authentication/SchoolLoginModel";
import { FaArrowRightLong } from "react-icons/fa6";
import { MdOutlineOndemandVideo } from "react-icons/md";
import { FaCirclePlay } from "react-icons/fa6";
import { useSelector } from "react-redux";
import ChatBotWidget from "./ChatBot";
import twitter_image from "../assets/images/twitter-image.jpeg"
import AnnouncementStrip from "../Components/AnnouncementStrip";
import { swachhataPosterSlides, SwachhataVideoSection } from "../Components/SwachhataHome";
import Sc6Hero from "../Components/SpecialCampaign6/Sc6Hero";
import { isSc6Shown } from "../Components/SpecialCampaign6/sc6Config";
import BricsHeroSection from "../Components/SchoolAdmin/BricsCampaign/BricsHeroSection";
import { isBricsShown } from "../Components/SchoolAdmin/BricsCampaign/bricsConfig";
import "./HomeHero.css";

import educationReimagined from "../assets/images/education_reimagined.png";

import secondaryStage from "../assets/images/secondary_stage_english.png";
import secondaryStagehindi from "../assets/images/secondary_stage_hindi.png";
import middlestageenglish from "../assets/images/middlest.png";
import middlestagehindi from "../assets/images/middle_stage_hindi.png";

import sechindi from "../assets/images/sec_hindi.png";
import idy from "../assets/images/idy.png";
import idyBook from "../assets/images/IDY - REPORT - 2025 v19.pdf";
import nep5yearsBook from "../assets/images/Ready Reckoner_NEP2020(HQ).pdf";
import nep5years from "../assets/images/nep5years.png";
import schoolBook from "../assets/images/School Diary (Hindi) 2025-26.pdf";
import schoolDiary from "../assets/images/schoolDiary.png";
import schoolDiaryEnglish from "../assets/images/School Diary (English) 2025-26 - UN476.pdf";
import schoolBookEnglish from "../assets/images/schooldiaryenglish.png"
import earthDayImage from "../assets/images/EarthDay 26 (2).png";

function HomePage() {
  // const scrollToTop = () => {
  //   window.scrollTo({
  //     top: 0,
  //     behavior: "smooth",
  //   });
  // };
  // scrollToTop()
  const [modalShow, setModalShow] = useState(false);
  const userData = useSelector(state => state.auth.user);
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [imageUrl, setImageUrl] = useState(null);
  const location = useLocation(); // Get the current location
  const { sectionId, setSectionId } = useContext(AppContext); // Get sectionId and setSectionId from context
  console.log(location, "location");
  const [role, setRole] = useState("");
  const [showSchoolLogin, setShowSchoolLogin] = useState(false);
  const [isVideoVisible, setIsVideoVisible] = useState(false);
  const [participants, setParticipants] = useState(0);
  const [eventsCount, setEventsCount] = useState(0);
  const [pledges, setPledges] = useState(0);
  const [matchingCount, setMatchingCount] = useState(0);
  const [uniqueDistrictCount, setUniqueDistrictCount] = useState(0);
  const [uniqueStateCount, setUniqueStateCount] = useState(0);
  const [totalNotifications, setTotalNotifications] = useState(0);
  const [notificationReportData, setNotificationReportData] = useState(null);

  const handleVideoLoad = () => {
    setIsVideoVisible(true);
  };

  const getCount = async (data) => {
    try {
      const response = await fetch('https://ecoclubs.education.gov.in/api/homepage-count', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();

      if (result.status === 'success') {
        const counts = result.data.matchCount;

        setMatchingCount(counts.matchingCount);
        setUniqueDistrictCount(counts.uniqueDistrictCount);
        setUniqueStateCount(counts.uniqueStateCount);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchTotalNotifications = async () => {
    try {
      // Fetch both total count and full report data
      const [totalResponse, reportResponse] = await Promise.all([
        fetch('https://ecoclubs.education.gov.in/api/school-notifications/total'),
        fetch('https://ecoclubs.education.gov.in/api/school-notifications/all-states')
      ]);

      const totalResult = await totalResponse.json();
      const reportResult = await reportResponse.json();

      if (totalResult.status === 'success') {
        setTotalNotifications(totalResult.totalCount || 0);
      }

      if (reportResult.status === 'success') {
        const transformedData = reportResult.stateCounts.map(item => ({
          stateName: item.state,
          notifications: item.count
        }));
        setNotificationReportData({
          stateData: transformedData,
          totalCount: reportResult.totalCount || 0
        });
      }
    } catch (error) {
      console.log('Error fetching total notifications:', error);
      setTotalNotifications(0);
    }
  };



  const [books, setBooks] = useState([
    {
      "_id": 1027,
      "book_title": "Yoga for One Earth, One Health",
      "book_cover_img": idy,
      "book_desc": "",
      "book_cat": 0,
      "category_name": "Education",
      "book_author": 0,
      "book_status": true,
      "book_publisher": 0,
      "book_link": idyBook,
      "book_year": 2026,
      "book_pages": 8,
      "language_id": 1,
      "author_name": "",
      "publisher_name": "",
      "avg_rating": 0.0,
      "download_count": 0,
      "language": "English",
      "downloaded_by_user": 0,
      "agegroup": "11 to 14",
      "user_book_count": 0
    },
    {
      "_id": 1027,
      "book_title": "5 Years National Education Policy",
      "book_cover_img": nep5years,
      "book_desc": "",
      "book_cat": 0,
      "category_name": "Education",
      "book_author": 0,
      "book_status": true,
      "book_publisher": 0,
      "book_link": nep5yearsBook,
      "book_year": 2026,
      "book_pages": 8,
      "language_id": 1,
      "author_name": "",
      "publisher_name": "",
      "avg_rating": 0.0,
      "download_count": 0,
      "language": "English",
      "downloaded_by_user": 0,
      "agegroup": "11 to 14",
      "user_book_count": 0
    },
    {
      "_id": 1027,
      "book_title": "Education Reimagined",
      "book_cover_img": educationReimagined,
      "book_desc": "",
      "book_cat": 0,
      "category_name": "Education",
      "book_author": 0,
      "book_status": true,
      "book_publisher": 0,
      "book_link": "https://ncert.nic.in/division/pd/pdf/Coffee_Table",
      "book_year": 2026,
      "book_pages": 8,
      "language_id": 1,
      "author_name": "",
      "publisher_name": "",
      "avg_rating": 0.0,
      "download_count": 0,
      "language": "English",
      "downloaded_by_user": 0,
      "agegroup": "11 to 14",
      "user_book_count": 0
    },
    {
      "_id": 1027,
      "book_title": "School Diary (Hindi) 2025-26",
      "book_cover_img": schoolDiary,
      "book_desc": "",
      "book_cat": 0,
      "category_name": "Education",
      "book_author": 0,
      "book_status": true,
      "book_publisher": 0,
      "book_link": schoolBook,
      "book_year": 2026,
      "book_pages": 8,
      "language_id": 1,
      "author_name": "",
      "publisher_name": "",
      "avg_rating": 0.0,
      "download_count": 0,
      "language": "English",
      "downloaded_by_user": 0,
      "agegroup": "11 to 14",
      "user_book_count": 0
    },
    {
      "_id": 1027,
      "book_title": "School Diary (English) 2025-26",
      "book_cover_img": schoolBookEnglish,
      "book_desc": "",
      "book_cat": 0,
      "category_name": "Education",
      "book_author": 0,
      "book_status": true,
      "book_publisher": 0,
      "book_link": schoolDiaryEnglish,
      "book_year": 2026,
      "book_pages": 8,
      "language_id": 1,
      "author_name": "",
      "publisher_name": "",
      "avg_rating": 0.0,
      "download_count": 0,
      "language": "English",
      "downloaded_by_user": 0,
      "agegroup": "11 to 14",
      "user_book_count": 0
    },
    {
      "_id": 1026,
      "book_title": "Preparatory stage ( Hindi )",
      "book_cover_img": "https://ecocloubsekpedimages.blob.core.windows.net/ecoclubs-missionlife-container/ek%20ped%20maa%20ke%20naam_20250729_144637.jpeg?sv=2025-11-05&ss=b&srt=sco&sp=rltfx&se=2027-04-16T17:55:51Z&st=2026-04-16T09:40:51Z&spr=https&sig=Z0GFb%2FGShGe%2BpuSQdDkpjJ6gJwkHl2Y1WdIxhL%2BWVMw%3D",
      "book_desc": "",
      "book_cat": 0,
      "category_name": "Environment",
      "book_author": 0,
      "book_status": true,
      "book_publisher": 0,
      "book_link": "https://ncert.nic.in/pdf/module/EPMKN/EPMKN_11-1PH.pdf",
      "book_year": 2023,
      "book_pages": 8,
      "language_id": 1,
      "author_name": "",
      "publisher_name": "",
      "avg_rating": 0.0,
      "download_count": 0,
      "language": "English",
      "downloaded_by_user": 0,
      "agegroup": "11 to 14",
      "user_book_count": 0
    },
    {
      "_id": 1026,
      "book_title": "Middle stage ( English )",
      "book_cover_img": middlestageenglish,
      "book_desc": "",
      "book_cat": 0,
      "category_name": "Environment",
      "book_author": 0,
      "book_status": true,
      "book_publisher": 0,
      "book_link": "https://ncert.nic.in/pdf/module/EPMKN/EPMKN_11-2ME.pdf",
      "book_year": 2023,
      "book_pages": 8,
      "language_id": 1,
      "author_name": "",
      "publisher_name": "",
      "avg_rating": 0.0,
      "download_count": 0,
      "language": "English",
      "downloaded_by_user": 0,
      "agegroup": "11 to 14",
      "user_book_count": 0
    },
    {
      "_id": 1026,
      "book_title": "Middle stage ( Hindi )",
      "book_cover_img": middlestagehindi,
      "book_desc": "",
      "book_cat": 0,
      "category_name": "Environment",
      "book_author": 0,
      "book_status": true,
      "book_publisher": 0,
      "book_link": "https://ncert.nic.in/pdf/module/EPMKN/EPMKN_11-2MH.pdf",
      "book_year": 2023,
      "book_pages": 8,
      "language_id": 1,
      "author_name": "",
      "publisher_name": "",
      "avg_rating": 0.0,
      "download_count": 0,
      "language": "English",
      "downloaded_by_user": 0,
      "agegroup": "11 to 14",
      "user_book_count": 0
    },
    {
      "_id": 1026,
      "book_title": "Secondary stage ( English )",
      "book_cover_img": secondaryStage,
      "book_desc": "",
      "book_cat": 0,
      "category_name": "Environment",
      "book_author": 0,
      "book_status": true,
      "book_publisher": 0,
      "book_link": "https://ncert.nic.in/pdf/module/EPMKN/EPMKN_11-3SE.pdf",
      "book_year": 2023,
      "book_pages": 8,
      "language_id": 1,
      "author_name": "",
      "publisher_name": "",
      "avg_rating": 0.0,
      "download_count": 0,
      "language": "English",
      "downloaded_by_user": 0,
      "agegroup": "11 to 14",
      "user_book_count": 0
    },
    {
      "_id": 1026,
      "book_title": "Secondary stage ( Hindi )",
      "book_cover_img": secondaryStagehindi,
      "book_desc": "",
      "book_cat": 0,
      "category_name": "Environment",
      "book_author": 0,
      "book_status": true,
      "book_publisher": 0,
      "book_link": "https://ncert.nic.in/pdf/module/EPMKN/EPMKN_11-2MH.pdf",
      "book_year": 2023,
      "book_pages": 8,
      "language_id": 1,
      "author_name": "",
      "publisher_name": "",
      "avg_rating": 0.0,
      "download_count": 0,
      "language": "English",
      "downloaded_by_user": 0,
      "agegroup": "11 to 14",
      "user_book_count": 0
    },

    {
      "_id": 1026,
      "book_title": "Secondary stage ( Hindi )",
      "book_cover_img": sechindi,
      "book_desc": "",
      "book_cat": 0,
      "category_name": "Environment",
      "book_author": 0,
      "book_status": true,
      "book_publisher": 0,
      "book_link": "https://ncert.nic.in/pdf/module/EPMKN/EPMKN_11-2MH.pdf",
      "book_year": 2023,
      "book_pages": 8,
      "language_id": 1,
      "author_name": "",
      "publisher_name": "",
      "avg_rating": 0.0,
      "download_count": 0,
      "language": "English",
      "downloaded_by_user": 0,
      "agegroup": "11 to 14",
      "user_book_count": 0
    },













  ]); // New state for books
  const [selectedBook, setSelectedBook] = useState(null); // State for selected book for modal
  var settings = {
    dots: true,
    infinite: true,
    speed: 100,
    slidesToShow: 6, // Set this to 6
    slidesToScroll: 2, // Set this to 3
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    margin: 15,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024, // Tablets
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 768, // Mobile devices
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480, // Smaller mobile devices
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  // Scroll to the section if sectionId is present in state
  React.useEffect(() => {
    console.log(sectionId); // Debug log to check the sectionId
    if (sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
        setSectionId(null); // Clear the section ID after scrolling
      } else {
        console.error(`Element with ID '${sectionId}' not found.`);
      }
    }
  }, [sectionId, setSectionId]);

  const handleRoute = (data) => {
    localStorage.setItem("theme_name", ThemeBaseRouting[data].value);
    navigate(ThemeBaseRouting[data].url);
  };

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await fetch('https://ecoclubs.education.gov.in/api/get-events');
        const data = await response.json();
        setEvents(data);
      } catch (error) {
        console.error('Error fetching events:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
    getCount();
    fetchTotalNotifications();
  }, []);
  useEffect(() => {
    // let token = localStorage.getItem("token");
    if (userData) {
      // let auth = jwtDecode(userData);
      // console.log(auth.role, "roling")
      setRole(userData.role);
    }
  }, [userData]);

  const handleEventApproval = () => {
    if (role === 2 || role === 3) {
      navigate("/school/eventlist");

    }
    else if (role === 1) {

    }
    else
      // toast.error("Please Login")
      setShowSchoolLogin(true)
  }

  const handleLogin = () => {
    if (role) {
      toast.success("Already Logged IN")
    } else
      setShowSchoolLogin(true)
  }
  const handleEventInitiation = () => {
    if (role === 2 || role === 3) {
      navigate("/school/createtheme");

    }
    else
      // toast.error("Please Login")
      setShowSchoolLogin(true)
  }
  const handleFacultyAssignment = () => {
    if (role === 2 || role === 3) {
      navigate("/school/event-assignment");

    }
    else
      // toast.error("Please Login")
      setShowSchoolLogin(true)
  }
  // ... existing code ...
  const handleCollaboration = () => {
    console.log("roling3")
    if (role === 2 || role === 3) {
      navigate("/school/notification");
      const element = document.getElementById("themes"); // Get the section by ID
      console.log(element, 'roling2')
      if (element) {
        console.log("Scrolling to themes section"); // Debug log
        element.scrollIntoView({ behavior: "smooth" }); // Scroll to the section
      } else {
        console.error("Element with ID 'themes' not found."); // Debug log
      }
    } else {
      // toast.error("Please Login")
      setShowSchoolLogin(true);
    }
  }
  // ... existing code ...

  // Fetch books data from the API
  // useEffect(() => {
  //   const fetchHomeData = async () => {
  //     try {
  //       const response = await fetch("https://ndl.education.gov.in/api/v1/homedata/?userid=8805b07af8e-c596-11ee-bf14-02001701a518&limit=10", {
  //         method: "GET",
  //         headers: {
  //           "Authorization": "ggPA3EFOr6k1jASp8&U",
  //           "Content-Type": "application/json"
  //         }
  //       });      const data = await response.json();
  //       const recommendedBooks = data.find(item => item.title === "Recommended Books");
  //       if (recommendedBooks) {
  //         // setBooks(recommendedBooks.books_data); // Set the books data
  //       }
  //     } catch (error) {
  //       console.error('Error fetching books:', error);
  //     }
  //   };

  //   fetchHomeData();
  // }, []);

  const handleShowModal = (book) => {
    console.log(book); // Check if the book object is correct
    setSelectedBook(book);
    setModalShow(true);
  };

  const handleCloseModal = () => {
    setModalShow(false);
    setSelectedBook(null);
  };

  // Fetch stats data from the API
  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await fetch('https://ecoclubs.education.gov.in/api/stats'); // Adjust the URL as needed
        const data = await response.json();
        // alert(data.totalParticipants)
        console.log(data, "data")
        setParticipants(data.data.totalParticipants);
        setEventsCount(data.data.totalEvents);
        setPledges(data.data.totalPledges);
      } catch (error) {
        console.error('Error fetching stats:', error);
      }
    };

    fetchStats();
  }, []);


  const Video1handleClick = () => {
    window.location.href = 'https://aictevoicestaanuvadini.blob.core.windows.net/ecoclubs/Prakriti2.mp4?sp=r&st=2026-02-06T06:00:58Z&se=2026-12-31T14:15:58Z&spr=https&sv=2024-11-04&sr=c&sig=n4zcC%2FICuzy6IgQ62mGtREv%2FQI3HUeu2TFULEdZkDyI%3D';
  };

  const Video2handleClick = () => {
    window.location.href = 'https://aictevoicestaanuvadini.blob.core.windows.net/ecoclubs/Prakriti1.mp4?sp=r&st=2026-02-06T06:00:58Z&se=2026-12-31T14:15:58Z&spr=https&sv=2024-11-04&sr=c&sig=n4zcC%2FICuzy6IgQ62mGtREv%2FQI3HUeu2TFULEdZkDyI%3D'
  }

  // The hero carousel fills the rest of the first screen (below the sticky header and the
  // announcement strip), so the next section starts on the second screen. HomeHero.css
  // applies --hero-h on desktop only.
  const heroRef = useRef(null);
  const [heroH, setHeroH] = useState(null);
  // Special Campaign 6 highlight: view-only before the campaign day, live on it.
  const [sc6Live] = useState(() => isSc6Shown());
  const [bricsLive] = useState(() => isBricsShown());
  useLayoutEffect(() => {
    const el = heroRef.current;
    if (!el) return undefined;
    const measure = () => {
      // the campaign banner sits above the carousel; the carousel still
      // gets a full screen of its own below it
      const sc6 = document.querySelector(".sc6-banner");
      const top = el.getBoundingClientRect().top + window.scrollY - (sc6 ? sc6.offsetHeight : 0);
      setHeroH(Math.max(360, Math.round(window.innerHeight - top)));
    };
    measure();
    window.addEventListener("resize", measure);
    window.addEventListener("load", measure);
    // the header logos and the strip settle once fonts and images load
    const ro = typeof ResizeObserver !== "undefined" ? new ResizeObserver(measure) : null;
    [document.querySelector("header"), document.querySelector(".ann-strip"), document.querySelector(".sc6-banner")].forEach((n) => n && ro?.observe(n));
    return () => {
      window.removeEventListener("resize", measure);
      window.removeEventListener("load", measure);
      ro?.disconnect();
    };
  }, []);


  return (
    <>
      {/* Swachhata Hi Seva · daily handholding · notifications report — one static bar */}
      <AnnouncementStrip
        totalNotifications={totalNotifications}
        notificationReportData={notificationReportData}
      />

      {/* Special Campaign 6 (E-Waste) — right under the strip until the campaign day ends */}
      {sc6Live && <Sc6Hero />}

      {/* BRICS Sustainable Lifestyle Week — the same slot, 1-7 Nov 2026 */}
      {bricsLive && <BricsHeroSection />}

      <section
        ref={heroRef}
        className="sliderSec sliderSec--fill"
        style={heroH ? { "--hero-h": `${heroH}px` } : undefined}
      >
        <Carousel fade>
          {/* <Carousel.Item>
            <img src={earthDayImage} alt="" />
          </Carousel.Item> */}
          {/* the quote is part of this image, so it is shown whole (never cropped) */}
          <Carousel.Item className="sliderSec__contain">
            <img src={banner22} alt="" />
          </Carousel.Item>
          {/* Swachhata Hi Seva 2026 — the six Solid Waste Management posters */}
          {swachhataPosterSlides()}
          <Carousel.Item>
            <img src={banner} alt="" />
            <Carousel.Caption className="text-start animate_animated animate_fadeInLeft">
              <h3>Eco Clubs For Mission LiFE</h3>
              <p>
                Eco Clubs For Mission LiFE inspire people to embrace a sustainable lifestyle by
                prioritizing eco-friendly choices in their everyday routine,
                empowering individuals to lead a greener life.
              </p>
              <button>
                Explore More <Image src={arrowRight} width="32px" />
              </button>
            </Carousel.Caption>
            {/* <div className="prakartiimg animate_animated animate_fadeInUp">
              <Image src={prakartiimg} width="300px" />
            </div> */}
          </Carousel.Item>
          <Carousel.Item>
            <img src={banner03} alt="" />
            {/* <Carousel.Caption className="animate_animated animate_fadeInLeft">
              <h3>Eco Clubs For Mission Life</h3>
              <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
              <button>Explore More <ArrowRight size={32} color="#e8b264" /></button>
            </Carousel.Caption> */}
          </Carousel.Item>

          <Carousel.Item>
            <img src={banner04} alt="" />
            {/* <Carousel.Caption className="animate_animated animate_fadeInLeft">
              <h3>Eco Clubs For Mission Life</h3>
              <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
              <button>Explore More <ArrowRight size={32} color="#e8b264" /></button>
            </Carousel.Caption> */}
          </Carousel.Item>
          
        </Carousel>

      </section>

      {/* Swachhata Hi Seva — SWM Rules 2026 video + public school-reports link */}
      <SwachhataVideoSection />
      {/* <section className="merqeeSec">
        <div className="container">
          <marquee behavior="alternate" direction="right" scrollamount="10" loop="">
            <Link to="/plantation">Green Milestone: <span>5.5 Crore</span> Saplings Planted Nationwide! #एक पेड़ माँ के नाम</Link>
            
            </marquee>
        </div>
      </section> */}
      <section
        className="sevenScopeSec animate_animated animate_fadeInUp "
        id="themes"
      >
        <div className="VideoButtonsnewone">
          <h4>Listen to Prakriti's message!</h4>
          <button className="btn-login-signup loginBtnnewhm" style={{ padding: "7px 20px", borderRadius: 8 }} onClick={Video2handleClick}>Hindi</button>
          <button className="btn btn-primary" onClick={Video1handleClick}>English</button>


        </div>

        {/* <img class="slider__shape-13" src={leafIcn} alt="" /> */}
        <div className="container-fluid">
          {/* <span class="contact__shape-1"></span> */}
          <div className="d-flex justify-content-center">
            <Image src={titleSample} />
            <div className="ecoclubsTitle mx-3">
              <h2>ECO CLUBS</h2>
              <h3>For Mission LiFE Themes</h3>
            </div>
            <Image src={titleSample} />
          </div>
          <div className="sevenScopeBox">
            <ul>
              <li onClick={() => handleRoute(0)}>
                {/* <Link to="/addopthealthylife"> */}
                <div className="themeBox animate_animated animate_fadeInLeft">
                  <div className="themeBoxCnt">Adopt Healthy Lifestyles</div>
                  <button>
                    <span>
                      <ArrowRight size={25} color="#e8b264" />
                    </span>{" "}
                    Read More
                  </button>
                  <div className="themeBoxIcn">
                    <img src={healthy} alt="" />
                  </div>
                </div>
                {/* </Link> */}
              </li>
              <li onClick={() => handleRoute(1)}>
                {/* <Link to="/addoptfood"> */}
                <div className="themeBox orange animate_animated animate_fadeInLeft">
                  <div className="themeBoxCnt">
                    Adopt Sustainable Food Systems
                  </div>
                  <button>
                    <span>
                      <ArrowRight size={25} color="#e8b264" />
                    </span>{" "}
                    Read More
                  </button>
                  <div className="themeBoxIcn">
                    <img src={food} alt="" />
                  </div>
                </div>
                {/* </Link> */}
              </li>
              <li onClick={() => handleRoute(3)}>
                {/* <Link to="/reduce-waste"> */}
                <div className="themeBox orange3 animate_animated animate_fadeInRight">
                  <div className="themeBoxCnt">Reduce Waste</div>
                  <button>
                    <span>
                      <ArrowRight size={25} color="#e8b264" />
                    </span>{" "}
                    Read More
                  </button>
                  <div className="themeBoxIcn" style={{ bottom: "-12px" }}>
                    <img src={waste} alt="" />
                  </div>
                </div>
                {/* </Link> */}
              </li>
              <li onClick={() => handleRoute(2)}>
                {/* <Link to="/reduceewaste "> */}
                <div className="themeBox orange4 animate_animated animate_fadeInRight">
                  <div className="themeBoxCnt">Reduce E-Waste</div>
                  <button>
                    <span>
                      <ArrowRight size={25} color="#e8b264" />
                    </span>{" "}
                    Read More
                  </button>
                  <div className="themeBoxIcn">
                    <img src={ewaste} alt="" />
                  </div>
                </div>
                {/* </Link> */}
              </li>
              <li onClick={() => handleRoute(4)}>
                {/* <Link to="/save-energy"> */}
                <div className="themeBox orange5 animate_animated animate_fadeInUp">
                  <div className="themeBoxCnt">Save Energy</div>
                  <button>
                    <span>
                      <ArrowRight size={25} color="#e8b264" />
                    </span>{" "}
                    Read More
                  </button>
                  <div className="themeBoxIcn">
                    <img src={energy} alt="" />
                  </div>
                </div>
                {/* </Link> */}
              </li>
              <li onClick={() => handleRoute(5)}>
                {/* <Link to="/savewater"> */}
                <div className="themeBox orange6 animate_animated animate_fadeInUp">
                  <div className="themeBoxCnt">Save Water</div>
                  <button>
                    <span>
                      <ArrowRight size={25} color="#e8b264" />
                    </span>{" "}
                    Read More
                  </button>
                  <div className="themeBoxIcn">
                    <img src={water} alt="" />
                  </div>
                </div>
                {/* </Link> */}
              </li>
              <li onClick={() => handleRoute(6)}>
                {/* <Link to="/saynoplastic"> */}
                <div className="themeBox orange7 animate_animated animate_fadeInUp">
                  <div className="themeBoxCnt">
                    Say No to Single Use Plastic
                  </div>
                  <button>
                    <span>
                      <ArrowRight size={25} color="#e8b264" />
                    </span>{" "}
                    Read More
                  </button>
                  <div className="themeBoxIcn">
                    <img src={plastic} alt="" />
                  </div>
                </div>
                {/* </Link> */}
              </li>
              {/* <li>
                <Link to="/VeerBalDetailsPage">
                <div className="themeBox orange8 animate_animated animate_fadeInUp">
                  <div className="themeBoxCnt">
                  Veer Bal Diwas
                  </div>
                  <button>
                    <span>
                      <ArrowRight size={25} color="#e8b264" />
                    </span>{" "}
                    Read More
                  </button>
                  <div className="themeBoxIcn">
                    <img src={veer} alt="" />
                  </div>
                </div>
                </Link>
              </li> */}
            </ul>
          </div>
        </div>
      </section>
      <section className="aboutEcoSec mb-0" id="aboutEcoClubs">
        <div className="container-fluid">
          <div className="row">
            <div className="col-6 abtSecR">
              <div className="abtSecRIn animate_animated animate_fadeInLeft">
                {!isVideoVisible ? (
                  <>
                    <img
                      src={modiji}
                      alt="Eco Clubs for Mission LiFE"
                      style={{ width: "100%", cursor: "pointer" }}
                      onClick={handleVideoLoad}
                    />
                    <div className="playIcons"><FaCirclePlay size={40} onClick={handleVideoLoad} color="#f04" /></div>
                  </>
                ) : (
                  <video width="100%" controls autoPlay>
                    <source
                      src="https://aictevoicestaanuvadini.blob.core.windows.net/ecoclubs/file_example_MP4_480_1_5MG.mp4?sp=r&st=2026-02-06T06:00:58Z&se=2026-12-31T14:15:58Z&spr=https&sv=2024-11-04&sr=c&sig=n4zcC%2FICuzy6IgQ62mGtREv%2FQI3HUeu2TFULEdZkDyI%3D"
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </video>
                )}
              </div>
            </div>
            <div className="col-6 abtSecL">
              <div className="abtSecLIn animate_animated animate_fadeInRight">
                <div className="d-flex justify-content-start align-items-center">
                  <Image src={titleSample} width={17} height={80} />
                  <div className="clubTitle">
                    <h2>About <span className="hdngBrkr"></span></h2>
                    <h3>Eco Clubs For Mission LiFE</h3>
                  </div>
                  <Image src={titleSample} width={17} height={80} />
                </div>
                <p className="pt-4">
                  The National Education Policy (NEP) 2020 emphasizes the critical importance of integrating environmental awareness and sustainability principles into school curricula. The vision of the Policy is to instil ‘among the learners a deep-rooted pride in being Indian… and dispositions that support responsible commitment to sustainable development and living…’ The policy also highlights ancient Indian traditions of environmental conservation, aligning them with modern scientific understanding.
                </p>
                <p>
                  Eco Clubs for Mission LiFE (Lifestyle for Environment) are a significant initiative to promote environmental consciousness among students. These clubs aim to instil values and behaviours necessary for sustainable living. Students are encouraged to participate in environment-friendly activities aligned with Mission LiFE themes, fostering a sense of responsibility towards nature. Mission LiFE is a global initiative put forth by our Hon’ble Prime Minister promoting mindful resource utilization for protection/conservation of the environment that Eco Clubs for Mission LiFE aim to propagate. The activities carried out under these clubs are aligned with seven themes of Mission LiFE.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="fiveStepSection py-5">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12 fiveStep">
              <div className="d-flex justify-content-center mb-2">
                <Image src={titleSample} className="titleimg" />
                <div className="ecoclubsTitle mx-3">
                  <h2 style={{ textTransform: "capitalize" }}>Steps to access and record participation</h2>
                  {/* <h3>For Mission LiFE</h3> */}
                </div>
                <Image src={titleSample} className="titleimg" />
              </div>
            </div>
            <ChatBotWidget />
            <ul className="infoGraphic">
              <li onClick={handleLogin}>
                <div className="numberWrap">
                  <div className="number fontColor1">1</div>
                  <div className="coverWrap">
                    <div className="numberCover"></div>
                  </div>
                </div>
                <div className="content">
                  <div className="icon iconCodepen">
                    <Image src={one} />
                  </div>
                  <h2>School Login Access</h2>
                  <p>Enable school logins using UDISE ID and OTP for secure access.</p>
                  {/* <button >Login</button> */}
                </div>
              </li>
              <li onClick={handleEventInitiation}>
                {/* <a href="" target="_blank"> */}
                <div className="numberWrap">
                  <div className="number fontColor2">2</div>
                  <div className="coverWrap">
                    <div className="numberCover"></div>
                  </div>
                </div>
                {/* <Link to="/explore-courses"> */}
                <div className="content">
                  <div className="icon iconSocial">
                    <Image src={two} />
                  </div>
                  <h2>Event Initiation</h2>
                  <p>Upon login, schools can initiate events based on Mission LiFE themes.</p>
                </div>
                {/* </Link> */}
                {/* </a> */}
              </li>
              <li onClick={handleFacultyAssignment}>
                {/* <a href="" target="_blank"> */}
                <div className="numberWrap">
                  <div className="number  fontColor3">3</div>
                  <div className="coverWrap">
                    <div className="numberCover"></div>
                  </div>
                </div>
                {/* <Link to="/registerseeker"> */}
                <div className="content">
                  <div className="icon iconAirplane">
                    <Image src={three} />
                  </div>
                  <h2>Faculty Assignment</h2>
                  <p>Schools can add and assign faculty members to manage the events effectively.</p>
                </div>
                {/* </Link> */}
                {/* </a> */}
              </li>
              <li onClick={handleEventApproval}>
                {/* <a href="" target="_blank"> */}
                <div className="numberWrap">
                  <div className="number  fontColor4">4</div>
                  <div className="coverWrap">
                    <div className="numberCover"></div>
                  </div>
                </div>
                {/* <Link to="/profile"> */}
                <div className="content" >
                  <div className="icon iconMap">
                    <Image src={four} />
                  </div>
                  <h2>Event Approval</h2>
                  <p>Mission LiFE theme events require approval by the school login only.</p>
                </div>
                {/* </Link> */}
                {/* </a> */}
              </li>
              <li onClick={handleCollaboration}>
                {/* <a className="fontColor5" href="" target="_blank"> */}
                <div className="numberWrap">
                  <div className="number  fontColor5">5</div>
                  <div className="coverWrap">
                    <div className="numberCover"></div>
                  </div>
                </div>
                <div className="content">
                  <div className="icon iconPeace">
                    <Image src={five} />
                  </div>
                  <h2>Collaboration Across Schools</h2>
                  <p>Schools across India can collaborate with the host school.</p>
                </div>
                {/* </a> */}
              </li>
              <li >
                {/* <a className="fontColor5" href="" target="_blank"> */}
                <div className="numberWrap">
                  <div className="number fontColor6">6</div>
                  <div className="coverWrap">
                    <div className="numberCover"></div>
                  </div>
                </div>
                <div className="content">
                  <div className="icon iconPeace">
                    <Image src={six} />
                  </div>
                  <h2>Impact Analysis</h2>
                  <p>Capture, generate, and analyze the impact of Mission LiFE theme-based activities.</p>
                </div>
                {/* </a> */}
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section className="thrdSec" id="objectivesGoals">
        {/* Background Decorations */}
        <div className="bg-blob blob-1"></div>
        <div className="bg-blob blob-2"></div>
        <div className="leaf-decor leaf-1"></div>
        <div className="leaf-decor leaf-2"></div>
        <div className="leaf-decor leaf-3"></div>

        <div className="container-fluid">
          <div className="d-flex justify-content-center mb-4">
            <Image src={titleSample} />
            <div className="ecoclubsTitle mx-3">
              <h2>Overarching</h2>
              <h3>Objectives & Goals</h3>
            </div>
            <Image src={titleSample} />
          </div>
          <div className="thrdContentDiv">
            <ul>
              <li>
                <div className="thrdbx bx_1 animate_animated animate_fadeInLeft">
                  <span className="topbxIccn">
                    <Image src={igniting} width="100%" />
                  </span>
                  <h2>Igniting Environmental Awareness: </h2>
                  <p>
                    Empower students and communities to grasp the urgency of
                    reducing carbon footprint and safeguarding our environment.
                  </p>
                </div>
              </li>
              <li>
                <div className="thrdbx bx_2 animate_animated animate_fadeInRight">
                  <span className="topbxIccn">
                    <Image src={globlazing} width="100%" />
                  </span>
                  <h2>Inculcating Pro-environment Behavior </h2>
                  <p>
                    Extend the reach of Mission LiFE's goals to every school,
                    embedding eco-conscious practices into daily life and
                    education.
                  </p>
                </div>
              </li>
              <li>
                <div className="thrdbx bx_3 animate_animated animate_fadeInLeft">
                  <span className="topbxIccn">
                    <Image src={empworing} width="100%" />
                  </span>
                  <h2>Empowering Grassroots Initiatives: </h2>
                  <p>
                    Act as a force multiplier by empowering grassroots eco-clubs
                    and local environmental initiatives, magnifying their impact
                    through a networked approach and collective action
                  </p>
                </div>
              </li>

              <li>
                <div className="thrdbx bx_4 animate_animated animate_fadeInRight">
                  <span className="topbxIccn">
                    <Image src={fostering} width="100%" />
                  </span>
                  <h2>Fostering Collaboration: </h2>
                  <p>
                    Cultivate a platform where stakeholders can seamlessly
                    exchange insights and champion best eco-friendly practices,
                    fostering a culture of collaboration.
                  </p>
                </div>
              </li>
              <li>
                <div className="thrdbx bx_5 animate_animated animate_fadeInLeft">
                  <span className="topbxIccn">
                    <Image src={breaking} width="100%" />
                  </span>
                  <h2>Breaking Language Barriers: </h2>
                  <p>
                    Bridge linguistic divides by offering multilingual support,
                    enabling diverse communities worldwide to contribute and
                    benefit from shared eco-practices.
                  </p>
                </div>
              </li>
              <li>
                <div className="thrdbx bx_6 animate_animated animate_fadeInRight">
                  <span className="topbxIccn">
                    <Image src={harnessing} width="100%" />
                  </span>
                  <h2>Harnessing AI for Insight: </h2>
                  <p>
                    Leverage Artificial Intelligence to produce insightful
                    reports and analyses, unlocking deeper understanding and
                    fostering smarter, data-driven eco-friendly choices.
                  </p>
                </div>
              </li>
              <li>
                <div className="thrdbx bx_7 animate_animated animate_fadeInLeft">
                  <span className="topbxIccn">
                    <Image src={empworing} width="100%" />
                  </span>
                  <h2>Amplifying Sustainable Solutions: </h2>
                  <p>
                    Amplify eco-friendly initiatives on a global scale,
                    showcasing and promoting exemplary practices to inspire
                    worldwide adoption.
                  </p>
                </div>
              </li>
              <li>
                <div className="thrdbx bx_8 animate_animated animate_fadeInRight">
                  <span className="topbxIccn">
                    <Image src={measuring} width="100%" />
                  </span>
                  <h2>Measuring Global Impact: </h2>
                  <p>
                    Establish robust metrics to quantify our impact on a large
                    scale, attracting the attention and support needed to fuel
                    ongoing environmental progress.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <Modal size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered show={modalShow} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{selectedBook ? selectedBook.book_title : ''}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="publicationModal">
          {selectedBook && (
            <div className="row p-3">
              <div className="col-12 col-sm-12 col-md-4 lg-4">
                <div className="imageborder">
                  <img src={selectedBook.book_cover_img} alt="Book Cover" className="img-fluid mb-3 w-100" />
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-8 col-lg-8">
                {/* <h4>Authors: {selectedBook.author_name}</h4>
                <h4>Publisher: {selectedBook.publisher_name}</h4>
                <h4>Average Rating: {selectedBook.avg_rating}</h4>
                <h4>Total Pages: {selectedBook.book_pages}</h4>
                <h4>Year: {selectedBook.book_year}</h4>
                <h4>Category: {selectedBook.category_name}</h4>
                <h4>Download Count: {selectedBook.download_count}</h4>
                <h4>Language: {selectedBook.language}</h4> */}
                <Table bordered>
                  <tbody>
                    <tr>
                      <td>Authors</td>
                      <td>{selectedBook.author_name}</td>
                    </tr>
                    <tr>
                      <td>Publisher:</td>
                      <td>{selectedBook.publisher_name}</td>
                    </tr>
                    <tr>
                      <td>Average Rating: </td>
                      <td>{selectedBook.avg_rating}</td>
                    </tr>
                    <tr>
                      <td>Total Pages:</td>
                      <td>{selectedBook.book_pages}</td>
                    </tr>
                    <tr>
                      <td>Year:</td>
                      <td>{selectedBook.book_year}</td>
                    </tr>
                    <tr>
                      <td>Category:</td>
                      <td> {selectedBook.category_name}</td>
                    </tr>
                    <tr>
                      <td>Download Count: </td>
                      <td>{selectedBook.download_count}</td>
                    </tr>
                    <tr>
                      <td>Language:</td>
                      <td>{selectedBook.language}</td>
                    </tr>
                  </tbody>
                </Table>

                <Button variant="primary" href={selectedBook.book_link} target="_blank" rel="noopener noreferrer">
                  Read Book
                </Button>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 mt-3">
                <p><strong>Description:</strong> {selectedBook?.book_desc}</p>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>Close</Button>
        </Modal.Footer>
      </Modal>
      <section className="stackHolderSec" id="publications">
        <div className="container-fluid">
          <div className="d-flex justify-content-center mb-4">
            <Image src={titleSample} />
            <div className="ecoclubsTitle mx-3">
              <h2>Publications</h2>
              <h3 style={{ letterSpacing: "0.08em" }}>For Mission LiFE</h3>
            </div>
            <Image src={titleSample} />
          </div>
          <Link className="expbutton" to="https://ndl.education.gov.in/" target="_blank">Explore National Digital Library <FaArrowRightLong color="#f89920" size={20} /></Link>
          <div className="publicationCntDiv">
            <Slider {...settings}>
              {books.map(book => (
                <div className="publicatinLst" key={book._id}>
                  <div className="publicationIcn">
                    <img src={book.book_cover_img} alt={book.book_title} />
                  </div>
                  <div className="publicationCnt">
                    <p>
                      {book.book_title} <br />
                      {/* {book.book_desc} */}
                    </p>
                    {
                      book?.book_desc ?
                        <button className="viewBtn" onClick={() => handleShowModal(book)}>Read More</button>
                        :
                        <Button className="viewBtn" href={book.book_link} target="_blank" rel="noopener noreferrer">
                          Read More
                        </Button>
                    }

                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>

      <section className="whatsNewUpcmngSec">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-md-8 col-lg-8 whatsNewSec">
              <div className="col-12 whatsnewCnt">
                <div className="whatsNewCntDiv animate_animated animate_fadeInLeft">
                  <div className="secHdngDiv">
                    <span>What's New</span>
                  </div>

                  <div className="whatsheight">
                    <ul>
                      <li>
                        <FaRegHandPointRight /> Eco Clubs For Mission LiFE Webinar PPT 16.04.2025
                        <Link to="https://aictevoicestaanuvadini.blob.core.windows.net/ecoclubs/EC4ML_ppt_16.04.25.pptx?sp=r&st=2025-04-07T11:28:24Z&se=2025-06-29T19:28:24Z&spr=https&sv=2024-11-04&sr=c&sig=UtTuVhtLRQnfbAGjsTlB4sFYcG44G5oJj20DM3pz2ZQ%3D" target="_blank" className="rdmoreWhtsnew">
                          Read more <FaLongArrowAltRight />
                        </Link>
                        <p className="newsDate">
                          <span>Date:</span>  16 APR 2025
                        </p>
                      </li>
                      <li>
                        <FaRegHandPointRight />D.O.dated 11.04.2025
                        <Link to="https://aictevoicestaanuvadini.blob.core.windows.net/ecoclubs/DOLetter.pdf?sp=r&st=2025-04-07T11:28:24Z&se=2025-06-29T19:28:24Z&spr=https&sv=2024-11-04&sr=c&sig=UtTuVhtLRQnfbAGjsTlB4sFYcG44G5oJj20DM3pz2ZQ%3D" target="_blank" className="rdmoreWhtsnew">
                          Read more <FaLongArrowAltRight />
                        </Link>
                        <p className="newsDate">
                          <span>Date:</span> 11 Apr 2025
                        </p>
                      </li>

                      <li>
                        <FaRegHandPointRight /> Green Milestone: <span>5.18 Crore</span> Saplings Planted Nationwide! एक पेड़ माँ नाम{" "}
                        <Link to="/plantation" target="_blank" className="rdmoreWhtsnew">
                          Read more <FaLongArrowAltRight />
                        </Link>
                        <p className="newsDate">
                          <span>Date:</span> 01-11-2024
                        </p>
                      </li>
                      <li>
                        <FaRegHandPointRight /> Department of School Education & Literacy and its Autonomous Bodies continue activities under Special Campaign 4.0
                        <Link to="https://pib.gov.in/PressReleasePage.aspx?PRID=2070149" target="_blank" className="rdmoreWhtsnew">
                          Read more <FaLongArrowAltRight />
                        </Link>
                        <p className="newsDate">
                          <span>Date:</span> 01 NOV 2024
                        </p>
                      </li>
                      <li>
                        <FaRegHandPointRight /> Last date for submitting applications (fresh & renewal) on National Scholarship Portal for 2024-25 under NMMSS extended till 15 November, 2024
                        <Link to="https://pib.gov.in/PressReleasePage.aspx?PRID=2070204" target="_blank" className="rdmoreWhtsnew">
                          Read more <FaLongArrowAltRight />
                        </Link>
                        <p className="newsDate">
                          <span>Date:</span> 01 NOV 2024
                        </p>
                      </li>
                      <li>
                        <FaRegHandPointRight /> 20 students from India to participate in Sakura Programme 2024
                        <Link to="https://pib.gov.in/PressReleasePage.aspx?PRID=2066381" target="_blank" className="rdmoreWhtsnew">
                          Read more <FaLongArrowAltRight />
                        </Link>
                        <p className="newsDate">
                          <span>Date:</span> 19 OCT 2024
                        </p>
                      </li>
                      <li>
                        <FaRegHandPointRight /> DO letter Janjatiya Gaurav Divas
                        <Link to="https://ecoclubs.education.gov.in/viewUpload/uploads/books/DO.pdf" target="_blank" className="rdmoreWhtsnew">
                          Read more <FaLongArrowAltRight />
                        </Link>
                        <p className="newsDate">
                          <span>Date:</span> 10 OCT 2024
                        </p>
                      </li>
                      <li>
                        <FaRegHandPointRight /> Ministry of Education organises workshop on Mental Health & Cyber Security on World Mental Health Day
                        <Link to="https://pib.gov.in/PressReleasePage.aspx?PRID=2063950" target="_blank" className="rdmoreWhtsnew">
                          Read more <FaLongArrowAltRight />
                        </Link>
                        <p className="newsDate">
                          <span>Date:</span> 10 OCT 2024
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-4 col-lg-4 eventsSpchsSec">
              {/* <div className="col-12 whatsHdng">
                <h2>Upcoming 
            <span className="hdngBrkr"> Events</span>   & Important <span className="hdngBrkr">Speeches</span>
          </h2>
                </div> */}
              <div className="col-12 eventsSpchs">
                {/* <span className="viewallBtn "><Link to='' className="button green btn-login-signup ">View all</Link></span> */}
                <div className="eventsSpchsDiv animate_animated animate_fadeInRight">
                  <Tabs
                    defaultActiveKey="events"
                    id="uncontrolled-tab-example"
                    className="mb-3"
                  >
                    <Tab eventKey="events" title="Upcoming Events">
                      {loading ? (
                        <p>Loading events...</p>
                      ) : events.length > 0 ? (
                        events.map(event => (
                          <div key={event._id}>
                            <h5>{event.event_name}</h5>
                            <p>School: {event.school_name}</p>
                            <p>
                              Date: {
                                (() => {
                                  const date = new Date(event.event_date);
                                  const day = date.getDate().toString().padStart(2, '0');
                                  const month = (date.getMonth() + 1).toString().padStart(2, '0');
                                  const year = date.getFullYear();
                                  return ` ${day}/${month}/${year}`;
                                })()
                              }
                            </p>
                            <p>Theme: {event.theme_name}</p>
                            <hr />
                          </div>
                        ))
                      ) : (
                        <p>No Events</p>
                      )}
                    </Tab>


                    <Tab eventKey="speeches" title="Important Speeches">
                      <div>
                        <Link className="videoLink" target="_blank" to="https://ecoclubs.education.gov.in/viewUpload/uploads/videos/Eco%20Clubs%20for%20Mission%20LiFE.mp4">
                          <MdOutlineOndemandVideo color="#f29620" /> About Eco Clubs For Mission LiFE</Link>
                      </div>
                    </Tab>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="stackHolderSec homeSocialSec mt-5" id="getSocial">
        <div className="container">
          <div className="d-flex justify-content-center mb-5">
            <Image src={titleSample} />
            <div className="ecoclubsTitle mx-3">
              <h2>Let's Get Social</h2>
              <h3>For Mission LiFE</h3>
            </div>
            <Image src={titleSample} />
          </div>
          <div className="d-flex justify-content-start flex-wrap">
            <div className="sclBoxOne">
              <div className="sclBoxOneIn animate_animated animate_fadeInLeft">
                <div className="sclBoxOneHdng">Facebook</div>
                <div className="sclBoxOneCnt">
                  <iframe
                    src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FEduMinOfIndia&tabs=timeline&width=500&height=450&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=false&appId"
                    width="100%"
                    height="450"
                    style={{ border: "none", overflow: "hidden" }}
                    scrolling="no"
                    frameborder="0"
                    allowfullscreen="true"
                    allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                  ></iframe>
                </div>
              </div>
            </div>
            <div className="sclBoxOne sclBoxTwo">
              <div className="sclBoxOneIn animate_animated animate_fadeInLeft">
                <div className="sclBoxOneHdng">X</div>

                <div className="sclBoxOneCnt" style={{ height: "450px" }}>
                  <a
                    href="https://x.com/EduMinOfIndia"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ width: "100%", height: "100%", display: "block" }}
                  >
                    <img
                      src={twitter_image} // Make sure you imported: import twitter_image from '../assets/images/twitter-banner.jpg';
                      alt="Ministry of Education Twitter Banner"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: "8px",
                        border: "1px solid #ccc",
                        cursor: "pointer",
                      }}
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="sclBoxOne sclBoxThree">
              <div className="sclBoxOneIn animate_animated animate_fadeInRight">
                <div className="sclBoxOneHdng">YouTube</div>
                <div className="sclBoxOneCnt">
                  <iframe
                    width="100%"
                    height="450"
                    src="https://www.youtube.com/embed/W5ZJdfrs1pY?si=yrfruYMcQDiDF-9-"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>
            </div>
            <div className="sclBoxOne sclBoxThree">
              <div className="sclBoxOneIn animate_animated animate_fadeInRight">
                <div className="sclBoxOneHdng">Instagram</div>
                <div className="sclBoxOneCnt">
                  <iframe
                    width="100%"
                    height="450"
                    src="https://www.instagram.com/p/DB_FJCjvJvQ/embed"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>
            </div>
            <div className="sclBoxOne">
              {/* <iframe
        src="https://www.linkedin.com/embed/feed/update/urn:li:share:6772473336518721536"
        width="100%"
        height="450"
        frameBorder="0"
        allowFullScreen={true}
        allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
        style={{ border: 'none', overflow: 'auto' }}
        title="LinkedIn Post"
      ></iframe> */}
            </div>
          </div>
        </div>
      </section>
      <section
        className="stackHolderSec bg"
        id="stakeholders"
        style={{ marginTop: 90 }}
      >
        <div className="container-fluid">
          <div
            className="d-flex justify-content-center mb-4"
            style={{ marginTop: -180 }}
          >
            <Image src={titleSample} />
            <div className="ecoclubsTitle mx-3">
              <h2 style={{ fontSize: 36 }}>Stakeholders Involved</h2>
              <h3 style={{ letterSpacing: " 0.3em" }}>For Mission LiFE</h3>
            </div>
            <Image src={titleSample} />
          </div>
          <div className="stackHldrCntDiv">
            <div className="text-center">
              <h2 className="sbHdng">participation AT A GLANCE</h2>
            </div>
            <div className="row">
              <div className="col-12 col-lg-6 stackLft animate_animated animate_fadeInLeft">

                <div className="stackLftIn">
                  <ul>
                    <li>
                      States/UTs <span>{Number(uniqueStateCount || 36).toLocaleString("en-IN")}</span>
                    </li>
                    <li>
                      Districts <span>{Number(uniqueDistrictCount || 787).toLocaleString("en-IN")}</span>
                    </li>
                    <li>
                      Total Schools <span>{Number(matchingCount || 7584).toLocaleString("en-IN")}</span>
                    </li>

                  </ul>
                </div>
              </div>
              <div className="col-6 col-lg-6 stackLft animate_animated animate_fadeInLeft">
                <div className="mobileLftIn">
                  <div className="stackLftIn">
                    <ul>
                      <li>
                        Participants <span>{Number(participants || 0).toLocaleString("en-IN")}</span>
                      </li>
                      <li>
                        Events <span>{Number(eventsCount || 0).toLocaleString("en-IN")}</span>
                      </li>
                      <li>
                        Pledges <span>{Number(pledges || 0).toLocaleString("en-IN")}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="ecoMobileApp">
        <div className="container-fluid">
          <div className="row">
            <div className="col-6 mobileLft">
              <div className="mobileLftIn">
                <img src={mobileApp} alt="" />
              </div>
            </div>
            
          </div>
        </div>
      </section> */}

      {showSchoolLogin && <SchoolLoginModel handleViewexit={() => setShowSchoolLogin(false)} />}
    </>
  );
}

function MyVerticallyCenteredModal(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <div className="modalDivCnt">
          <img src={props.imageUrl} alt="" />
          <div className="modalDivBtn">
            <span className="buttonLft">
              <FaArrowCircleLeft />
            </span>
            <span className="buttonRgt">
              <FaArrowCircleRight />
            </span>
          </div>
        </div>
      </Modal.Body>
      {/* <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer> */}
    </Modal>
  );
}

export default HomePage;
